import { render, staticRenderFns } from "./growthRecord.vue?vue&type=template&id=39221f07&scoped=true"
import script from "./growthRecord.vue?vue&type=script&lang=js"
export * from "./growthRecord.vue?vue&type=script&lang=js"
import style0 from "./growthRecord.vue?vue&type=style&index=0&id=39221f07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39221f07",
  null
  
)

export default component.exports